/**
 * Builds the `ArtifactAttachments` map that a communication-log entry records
 * for the files an outbound email carried. Consumer: `FormEmailModal`.
 * Invariant: only a commit that won the server's compare-and-set (`isCurrent`)
 * may name its version as the entry's `currentVersionId`; a version the server
 * recorded without moving the pointer is listed under `versions` alone, so the
 * map never claims a version the server did not make current.
 */
import { ArtifactAttachments } from '#types/System.types';
import type { UploadedAttachmentVersion } from '../../../../use/attachments/useAttachmentUpload';

export const artifactAttachmentsFromUploadResults = (
  results: UploadedAttachmentVersion[],
): ArtifactAttachments => {
  const out: ArtifactAttachments = {};
  for (const r of results) {
    out[r.fileUid] = {
      fileName: r.versionData.versionFileName,
      ...(r.isCurrent && { currentVersionId: r.versionId }),
      versions: { [r.versionId]: r.versionData },
      importance: 'mid',
    };
  }
  return out;
};
